module.exports = __webpack_public_path__ + "static/media/Melissa4.af6efb9c.jpg";